/**
 * Simplified Reducer
 * Most actions just merge their payload into state.
 * Special handling for albumArts which needs deep merge.
 */
const Reducer = (state, action) => {
  // Special case: albumArts needs deep merge
  if (action.albumArts != null) {
    return {
      ...state,
      albumArts: {
        ...state.albumArts,
        ...action.albumArts
      }
    };
  }
  
  // Default: simple merge of action into state
  return { ...state, ...action };
};

export default Reducer;

